export const CHANGE_LOCALE = 'locale:change';
export const CHANGE_COUNTRY = 'locale:country';



/** WEBPACK FOOTER **
 ** ./src/redux/modules/i18n/action-types.js
 **/